<!-- <p>account-settings-home works!</p> -->
<div class='acc-tab-container_2 justify-content-center'>
    <div class="settings-tab-content text-center pt-5 mt-5 pb-5 mb-5">Account details will be added in the future</div>
</div>